import { ReactiveStore } from './types'

let reactiveStore: ReactiveStore

const setFeatureFlags = (featureFlags: Record<string, boolean | string>) => {
  reactiveStore.data = featureFlags
}

const setReactiveStore = (store: ReactiveStore) => {
  reactiveStore = store
}

const getFeatureFlags = () => {
  return reactiveStore.data
}

export { setFeatureFlags, getFeatureFlags, setReactiveStore }
